{
  "list": {
    "title": "Frasa Pintar",
    "backToDashboard": "Dasbor",
    "newButton": "Frasa Baru",
    "import": "Impor",
    "export": "Ekspor",
    "searchPlaceholder": "Cari berdasarkan kunci atau teks ekspansi...",
    "filterAllCategories": "Semua Kategori",
    "header": "Frasa ({{count}})",
    "loading": "Memuat frasa...",
    "empty": "Tidak ada frasa. Buat frasa pintar pertama Anda.",
    "authoredBy": "oleh {{name}}",
    "tooltips": {
      "preview": "Pratinjau",
      "edit": "Edit",
      "delete": "Hapus"
    },
    "confirmDelete": "Konfirmasi",
    "cancelDelete": "Batal",
    "previewLabel": "Pratinjau:",
    "closePreview": "Tutup pratinjau",
    "toast": {
      "deleted": "Frasa dihapus",
      "importComingSoon": "Fitur impor akan segera hadir",
      "exportComingSoon": "Fitur ekspor akan segera hadir"
    }
  },
  "form": {
    "editTitle": "Edit Frasa Pintar",
    "createTitle": "Frasa Pintar Baru",
    "fields": {
      "key": "Kunci",
      "category": "Kategori",
      "expansionText": "Teks Ekspansi"
    },
    "required": "*",
    "keyPlaceholder": ".normalexam",
    "keyHelper": "Harus diawali dengan \".\"",
    "categoryUncategorized": "Tanpa Kategori",
    "expansionPlaceholder": "Teks yang akan menggantikan pintasan...",
    "cancel": "Batal",
    "create": "Buat Frasa",
    "update": "Perbarui Frasa",
    "toast": {
      "created": "Frasa dibuat",
      "updated": "Frasa diperbarui",
      "saveFailed": "Gagal menyimpan frasa",
      "keyMustStartWithDot": "Kunci harus diawali dengan \".\"",
      "keyTooShort": "Kunci minimal 2 karakter",
      "expansionRequired": "Teks ekspansi wajib diisi"
    }
  },
  "category": {
    "general": "Umum",
    "physicalExam": "Pemeriksaan Fisik",
    "reviewOfSystems": "Tinjauan Sistem",
    "assessment": "Asesmen",
    "plan": "Rencana",
    "instructions": "Instruksi",
    "medications": "Obat",
    "history": "Riwayat"
  }
}
